import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Card, CardContent, IconButton } from "@mui/material";
import yellowclock from "assets/icons/clock.svg";
import chevronright from "assets/icons/chevron-right.svg";
import book from "assets/icons/book.svg";
import { MdFileDownload } from "react-icons/md";
import { formatDuration } from "utilityFunction/convertMinToHours";
import { handleDownload } from "utilityFunction/donwloadFile";
import { API_ENDPOINTS } from "config/ApiConfig";

const DisciplineCardButton = ({ data }) => {
  const navigate = useNavigate();
  const [lessonInfo, setLessonInfo] = useState({});
  const [certificateUrl, setCertificateUrl] = useState("");

  useEffect(() => {
    if (data) {
      setLessonInfo(data);
    }
  }, [data]);

  useEffect(() => {
    if(lessonInfo && lessonInfo[0]?.certificate_code) {
      setCertificateUrl(`${API_ENDPOINTS.DOWNLOAD_CERTIFICATE}/${lessonInfo[0]?.certificate_code}.pdf`);
    }
  },[lessonInfo])
  return (
    lessonInfo && (
      <Card className="dashboard-card-content__download" onClick={() => handleDownload(certificateUrl)} sx={{ cursor: "pointer" }}>
        <CardContent className="dashboard-card-content__download-content">
          <Box className="dashboard-card-content__download-image-border">
            <Box component="img" src={book} />
          </Box>

          <Box sx={{ flexGrow: 1 }}>
            <Typography
              variant="subtitle1"
              component="div"
              className="dashboard-card-content__download-content-main-text"
            >
              Download Certificate
            </Typography>
            <Box className="dashboard-card-content__download-content-text-wrapper">
         
              <Typography
                variant="body2"
                className="dashboard-card-content__download-content-text"
              >
                {lessonInfo[0]?.certificate_code}
              </Typography>
            </Box>
          </Box>

          <IconButton
            edge="end"
            sx={{ p: 0 }}
            className="dashboard-card-content__download-content--iconButton"
          >
          
            <MdFileDownload />
          </IconButton>
        </CardContent>
      </Card>
    )
  );
};

export default DisciplineCardButton;
